const PLAN_TYPE_MAP = {
  ACCESS_FEE: 'accessFee',
  REGULAR: 'subscription',
  POSTPAID: 'postpaid'
};

function applicableConfig(rule) {
  return (rule && rule.applicableType) || null;
}

function planTypeFromConfig(config) {
  return PLAN_TYPE_MAP[config && config.type] || null;
}

function planTypeFromRule(rule) {
  return planTypeFromConfig(applicableConfig(rule));
}

function servicesForExclusion(configsBySdid, categoryServices) {
  return (categoryServices || []).filter((service) => {
    const config = configsBySdid && configsBySdid[service.serviceDetailId];
    return config && config.applicableForExclusion === true;
  });
}

function skipServiceHierarchyForMode(toggle, modeId, cityId) {
  if (toggle == null || modeId == null) {
    return false;
  }
  if (toggle === true) {
    return true;
  }
  if (Array.isArray(toggle)) {
    return toggle.some(id => String(id) === String(modeId));
  }
  if (typeof toggle !== 'object') {
    return false;
  }
  if (toggle['*'] === true || toggle.ALL === true) {
    return true;
  }
  const entry = toggle[modeId] !== undefined ? toggle[modeId] : toggle[String(modeId)];
  if (entry === undefined) {
    return false;
  }
  if (entry === true || entry === 'true') {
    return true;
  }
  if (Array.isArray(entry)) {
    if (!cityId) {
      return entry.length > 0;
    }
    return entry.some(id => String(id) === String(cityId) || String(id).toLowerCase() === 'all');
  }
  if (entry && typeof entry === 'object') {
    return entry[cityId] === true
      || entry[String(cityId)] === true
      || entry.ALL === true;
  }
  return false;
}

function eligibleRuleTypesFromRule(rule, fallback) {
  const config = applicableConfig(rule);
  const types = config && config.eligibleRuleTypes;
  if (Array.isArray(types) && types.length) {
    return types.filter((type) => type !== 'qualityReset');
  }
  return fallback || [];
}

function displayTitlesFromRule(rule) {
  const config = applicableConfig(rule);
  const titles = config && config.displayTitles;
  return Array.isArray(titles) ? titles : [];
}

function exclusiveOfTaxFromRule(rule) {
  const config = applicableConfig(rule);
  return !!(config && config.exclusiveOfTax);
}

function ruleTypeLabel(type) {
  if (type === 'zeroCommission') {
    return 'Zero Commission';
  }
  if (type === 'variableCommission') {
    return 'Variable Commission';
  }
  if (type === 'qualityReset') {
    return 'Quality Reset';
  }
  return type;
}

export { planTypeFromConfig, planTypeFromRule, servicesForExclusion, skipServiceHierarchyForMode, eligibleRuleTypesFromRule, displayTitlesFromRule, exclusiveOfTaxFromRule, ruleTypeLabel, applicableConfig };
